import axios from "axios";
import { API_URL, AUTH_API_URL, API_KEY } from "../configs";
import authAPI from "./authAPI";

console.log(API_KEY)

const apiInstance = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
    "X-API-Key": API_KEY, // Add API key to all requests
  },
  withCredentials: true, // Ensure cookies are sent
  timeout: 300000, // 5 minutes timeout for large uploads
});

// Attach CSRF token and API key to every request
apiInstance.interceptors.request.use(
  async (config) => {
    try {
      // Add API key to every request
      config.headers['X-API-Key'] = API_KEY;
      
      const csrfToken = await authAPI.getCsrfToken();
      if (csrfToken) {
        config.headers['X-CSRF-Token'] = csrfToken;
      }
    } catch (e) {
      // If fetching CSRF token fails, continue without it
    }
    return config;
  },
  (error) => Promise.reject(error)
);


let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

apiInstance.interceptors.response.use(
  response => response,
  async error => {
    // [Axios Interceptor] Error handler triggered
    const originalRequest = error.config;
    // Prevent infinite loop
    if (error.response && error.response.status === 401 && !originalRequest._retry && !originalRequest.url.endsWith("/auth/login") && !originalRequest.url.endsWith("/auth/refresh")) {
      // [Axios Interceptor] 401 detected, handling refresh logic
      if (isRefreshing) {
        // [Axios Interceptor] Refresh already in progress, queuing request
        // Queue the request until refresh is done
        return new Promise(function(resolve, reject) {
          failedQueue.push({ resolve, reject });
        })
        .then(() => apiInstance(originalRequest))
        .catch(err => Promise.reject(err));
      }
      originalRequest._retry = true;
      isRefreshing = true;
      try {
        // [Axios Interceptor] Sending refresh token request
        // Attempt to refresh token using the new refresh function with CSRF token
        const csrfToken = await authAPI.getCsrfToken();
        await authAPI.refresh(csrfToken);
        // [Axios Interceptor] Refresh token request complete
        processQueue(null);
        // Wait for cookies to update before retrying the original request
        await new Promise(res => setTimeout(res, 200));
        // Re-fetch CSRF token and set it on the original request before retrying
        const newCsrfToken = await authAPI.getCsrfToken();
        if (newCsrfToken) {
          originalRequest.headers = originalRequest.headers || {};
          originalRequest.headers['X-CSRF-Token'] = newCsrfToken;
        }
        // Retry the original request after refresh
        return apiInstance(originalRequest);
      } catch (refreshError) {
        // [Axios Interceptor] Refresh token request failed
        processQueue(refreshError, null);
        // Optionally: clear user state here
        try {
          const csrfToken = await authAPI.getCsrfToken();
          await authAPI.logout(csrfToken);
        } catch (e) {
          // Ignore logout errors
        }
        window.location.href = "/login";
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }
    return Promise.reject(error);
  }
);

export default apiInstance;

// Auth API instance for endpoints under AUTH_API_URL
export const authApiInstance = axios.create({
  baseURL: AUTH_API_URL,
  headers: {
    "Content-Type": "application/json",
    "X-API-Key": API_KEY, // Add API key to auth requests too
  },
  withCredentials: true,
});